<template>
    <FormFieldWrapper :label="label">
        <pbl-textarea
            :value="modelValue"
            :invalid="invalid"
            :maxlength="maxlength"
            @input="onPblInput"
        >
            <span
                v-if="invalid"
                slot="subline"
            >
                {{ errorMessage }}
            </span>
            <span
                v-if="maxlength"
                slot="subline"
                class="length-counter"
            >
                {{ inputLength }} / {{ maxlength }}
            </span>
        </pbl-textarea>
    </FormFieldWrapper>
</template>

<script setup lang="ts">
import FormFieldWrapper from '@/components/form-inputs/form-field-wrapper/FormFieldWrapper.vue'
import { computed } from 'vue'

const props = defineProps<{
    modelValue: string
    label?: string

    invalid?: boolean
    errorMessage?: string
    maxlength?: number
}>()

const emit = defineEmits<{
    'update:modelValue': [value: string]
}>()

const onPblInput = (event: InputEvent) => {
    const value = (event.target as HTMLInputElement)?.value ?? ''

    emit('update:modelValue', value)
}

const inputLength = computed<number>(() => {
    return props.modelValue?.length ? props.modelValue.length : 0
})
</script>

<style scoped lang="scss">
.length-counter {
    float: right;
    color: $pbl-text;
}
</style>
